import { memo } from 'react';
import { IImages } from '../../../mechanics/characters/Character';
import { useAppSelector } from '../../../store/store';
import ImgWithFallback from '../../ui/ImgWithFallback';

interface IEnemysAliveProps {
    enemyImg: IImages
    enemyHp: number
    maxEnemyHp: number
    widthHpBar: number
}

const EnemysAlive = ({ enemyImg, enemyHp, maxEnemyHp, widthHpBar }: IEnemysAliveProps) => {
    const ischoiceActive = useAppSelector(state => state.FightReducer.ischoiceActive)

    return (
        <>
            <ImgWithFallback
                src={enemyImg.webp}
                fallbackSrc={enemyImg.img}
                classNames={'enemies__content-img enemies'} />
            <div className="enemies__content-hp">
                <span style={{ width: `${widthHpBar}%` }}></span>
                <p>{enemyHp} / {maxEnemyHp}</p>
            </div>
            <div className="arrow-down" style={ischoiceActive ? { display: "block" } : {}}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </>
    );
};

export default memo(EnemysAlive);